import { inject, Pipe, PipeTransform } from '@angular/core';
import { transformAttributeService } from '../services/transform-attribute-service';

@Pipe({
  name: 'imageUrlTransformPipe',
  standalone: true,
})
export class ImageUrlTransformPipe implements PipeTransform {
  private _transformAttributeService = inject(transformAttributeService);

  transform(value: string | undefined | null, width: number, height: number): string {
    if (value) {
      return this._transformAttributeService.imageServiceUrl(value, width, height);
    } else {
      return '';
    }
  }
}
